

import FlowTextStyle from "./FlowText.module.scss";
import {MutableRefObject, startTransition, useEffect, useRef, useState} from "react";
import debounce from "lodash.debounce";


export const FlowText = (props: {
   className?: string,
   text: string,
   onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>)=>void,
   parent: MutableRefObject<HTMLElement|null>
}) => {


    const el = useRef<HTMLDivElement|null>(null);
    const [animate, setAnimate] = useState(0);
    const [className, setClassName] = useState("");
    useEffect(() => {
        if (!className) {
            setClassName(`anim_${new Date().getTime()}_${Math.ceil(Math.random() * 1000)}`);
        }
        const onResize = debounce(()=>{
            const r = el.current;
            if (r && props.parent?.current) {
                const sirkaTextu = r.getBoundingClientRect().width;
                const aRect = props.parent.current!.getBoundingClientRect();
                const sirkaDivu = (aRect.width + aRect.x) - r.parentElement!.getBoundingClientRect().x;
                if (sirkaDivu === 0 || sirkaDivu >= sirkaTextu) {
                    setAnimate(0);
                    return;
                }

                startTransition(() => {
                    setAnimate((sirkaTextu - sirkaDivu) / sirkaTextu);
                });
            }
        }, 300);
        onResize();
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.text, props.parent]);


    const StyleDef = (()=> {
        if (!animate)
            return null;
        let sec =4/animate;

        if (sec > 8)
            sec = 8;
        return <style>{`
          @keyframes slide-in-EpisodePlayerRow_${className}  {
             0% {
               transform: translateX(0);
             }
             50% {
               transform: translateX(${-animate * 100}%);
             }
             0%{
               transform: translateX(0%);
             }
          }
          .EpisodePlayerRow_animate_${className} {
            animation: slide-in-EpisodePlayerRow_${className} ${sec}s ease infinite;
          }          
        `}</style>
    })();

    return <>
        <div onClick={props.onClick} className={`${FlowTextStyle.flowText} ${props.className ? props.className : ""}`}>
            <div ref={el} className={animate ? `EpisodePlayerRow_animate_${className}` : ""} >{props.text}</div>
        </div>
        {StyleDef}
    </>
}